/* unplugin-vue-components disabled */import { render } from "./CrispSupport.vue?vue&type=template&id=5ce5bddc&scoped=true&ts=true"
import script from "./CrispSupport.vue?vue&type=script&lang=ts"
export * from "./CrispSupport.vue?vue&type=script&lang=ts"

import "./CrispSupport.vue?vue&type=style&index=0&id=5ce5bddc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce5bddc"]])

export default __exports__